import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Validate URL format
if (!supabaseUrl?.startsWith('https://')) {
  throw new Error('Invalid Supabase URL format');
}

// Create Supabase client with enhanced error handling
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  global: {
    headers: {
      'X-Client-Info': 'northstar-analytics'
    }
  }
});

// Connection health check utility
export const checkSupabaseConnection = async () => {
  try {
    const { data, error } = await supabase?.from('user_profiles')?.select('count', { count: 'exact', head: true });
    
    if (error) {
      if (error?.message?.includes('Database error')) {
        return {
          status: 'error',
          message: 'Supabase project may be paused or experiencing issues',
          details: error?.message,
          action: 'Check Supabase Dashboard: https://supabase.com/dashboard'
        };
      }
      return {
        status: 'error',
        message: error?.message,
        details: error
      };
    }
    
    return {
      status: 'connected',
      message: 'Supabase connection is healthy'
    };
  } catch (err) {
    return {
      status: 'error',
      message: 'Failed to connect to Supabase',
      details: err?.message,
      action: 'Verify VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env file'
    };
  }
};
